module.exports = __webpack_public_path__ + "img/bookmark-fill.0fb2a76b.svg";